type GroupType = Array<{
  label: string
  value: string
}>

export const group: GroupType = [
  { label: 'BILLING', value: 'BILLING' },
  { label: 'READONLY', value: 'RO' }
]
